import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const C = { navy: '#0D1B2A', teal: '#00B4D8', success: '#10B981', error: '#EF4444',
            grey: '#6B7280', border: '#E5E7EB', bg: '#F0F7FA', white: '#fff' };

const inp = { width: '100%', padding: '11px 14px', border: `1.5px solid ${C.border}`, borderRadius: 10, fontSize: 15, outline: 'none', boxSizing: 'border-box' };

export default function BookAssessment() {
  const params = new URLSearchParams(window.location.search);
  const parts = window.location.hostname.split('.');
  const isMain = parts.length < 3 || parts[0] === 'speakiq' || parts[0] === 'www';
  const subdomain = isMain ? (params.get('school') || '') : parts[0];

  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ name: '', email: '', phone: '' });
  const [selected, setSelected] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(null);

  useEffect(() => {
    if (!subdomain) { setLoading(false); return; }
    api.get(`/api/public/assessment-slots?subdomain=${subdomain}`)
      .then(r => setSlots(Array.isArray(r.data) ? r.data : []))
      .catch(() => setSlots([]))
      .finally(() => setLoading(false));
  }, [subdomain]);

  const book = async () => {
    setError('');
    if (!form.name || !form.email) { setError('Please enter your name and email.'); return; }
    if (!form.phone || form.phone.replace(/\D/g, '').length < 7) { setError('Please enter a valid phone number.'); return; }
    if (!selected) { setError('Please choose a date and time.'); return; }
    setSubmitting(true);
    try {
      const r = await api.post('/api/public/assessment-book', { subdomain, slot_id: selected, ...form });
      setDone(r.data);
    } catch (e) { setError(e.response?.data?.error || 'Could not book. Please try again.'); }
    setSubmitting(false);
  };

  const fmtSlot = (s) => {
    const d = new Date(s.date + 'T00:00:00');
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }) + ' · ' + s.time + (s.location ? ` · ${s.location}` : '');
  };

  return (
    <div style={{ minHeight: '100vh', background: C.bg }}>
      <div style={{ background: C.navy, padding: '16px 24px', color: C.white, fontWeight: 800, fontSize: 18 }}>SpeakIQ <span style={{ color: C.teal, fontWeight: 600, fontSize: 14 }}>· Free English Assessment</span></div>
      <div style={{ maxWidth: 560, margin: '0 auto', padding: '32px 20px' }}>
        {done ? (
          <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 16, padding: 32, textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 8 }}>✅</div>
            <h2 style={{ color: C.navy, margin: '0 0 8px' }}>Assessment booked!</h2>
            <p style={{ color: C.grey, lineHeight: 1.6 }}>See you at the centre. Please arrive a few minutes early and bring photo ID.</p>
            {done.login && (
              <div style={{ background: C.bg, border: `1px dashed ${C.teal}`, borderRadius: 12, padding: 18, marginTop: 16, textAlign: 'left' }}>
                <div style={{ fontWeight: 700, color: C.navy, marginBottom: 8 }}>Your assessment login</div>
                <div style={{ fontSize: 14, color: C.navy }}>Login page: <a href={done.login.login_url}>{done.login.login_url}</a></div>
                <div style={{ fontSize: 14, color: C.navy }}>Email: <strong>{done.login.email}</strong></div>
                <div style={{ fontSize: 14, color: C.navy }}>Password: <strong>{done.login.temp_password}</strong></div>
                <div style={{ fontSize: 12, color: C.grey, marginTop: 8 }}>Use these to sign in and take your assessment at the centre. Keep them safe.</div>
              </div>
            )}
          </div>
        ) : !subdomain ? (
          <div style={{ background: C.white, borderRadius: 16, padding: 32, textAlign: 'center', color: C.grey }}>Please open this from your school's website link.</div>
        ) : (
          <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 16, padding: 28 }}>
            <h1 style={{ color: C.navy, fontSize: 24, fontWeight: 800, margin: '0 0 4px' }}>Book your free assessment</h1>
            <p style={{ color: C.grey, margin: '0 0 20px', fontSize: 14 }}>Choose a time to come in and take your free English level assessment. No payment required.</p>

            <label style={{ fontSize: 13, fontWeight: 700, color: C.navy }}>Full name</label>
            <input style={{ ...inp, margin: '6px 0 14px' }} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Your name" />
            <label style={{ fontSize: 13, fontWeight: 700, color: C.navy }}>Email</label>
            <input style={{ ...inp, margin: '6px 0 14px' }} value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="you@example.com" />
            <label style={{ fontSize: 13, fontWeight: 700, color: C.navy }}>Phone</label>
            <input style={{ ...inp, margin: '6px 0 18px' }} value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} placeholder="+998 ..." />

            <label style={{ fontSize: 13, fontWeight: 700, color: C.navy }}>Choose a date &amp; time</label>
            {loading ? (
              <div style={{ color: C.grey, padding: 16 }}>Loading available times…</div>
            ) : slots.length === 0 ? (
              <div style={{ color: C.grey, padding: 16, fontSize: 14 }}>No assessment times are open right now. Please check back soon or contact the centre.</div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, margin: '8px 0 18px', maxHeight: 240, overflowY: 'auto' }}>
                {slots.map(s => (
                  <button key={s.id} onClick={() => setSelected(s.id)}
                    style={{ textAlign: 'left', padding: '12px 14px', borderRadius: 10, cursor: 'pointer',
                      border: `2px solid ${selected === s.id ? C.teal : C.border}`, background: selected === s.id ? '#E0F7FC' : C.white }}>
                    <span style={{ fontWeight: 600, color: C.navy }}>{fmtSlot(s)}</span>
                    <span style={{ float: 'right', fontSize: 12, color: C.grey }}>{s.available} seat{s.available !== 1 ? 's' : ''} left</span>
                  </button>
                ))}
              </div>
            )}

            {error && <div style={{ color: C.error, fontSize: 14, marginBottom: 12 }}>{error}</div>}
            <button onClick={book} disabled={submitting || slots.length === 0}
              style={{ width: '100%', padding: '13px', borderRadius: 10, background: C.teal, color: C.white, border: 'none', fontWeight: 700, fontSize: 15, cursor: 'pointer', opacity: (submitting || slots.length === 0) ? 0.6 : 1 }}>
              {submitting ? 'Booking…' : 'Book my free assessment'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
